import dayjs from "dayjs"

/** Payment window of the flight checkout (and repayment) page, counted from `current_time_session`. */
export const FLIGHT_CHECKOUT_SECONDS = 3300

/** Payment closes this long before the order's expiryDate (the BE hold), leaving time to finish paying. */
export const PAYMENT_EXPIRY_BUFFER_SECONDS = 5 * 60

/**
 * End of the payment window shown to the customer (checkout timer, My Booking countdown):
 * the order's expiryDate minus PAYMENT_EXPIRY_BUFFER_SECONDS. Null without a valid expiryDate.
 */
export const getPaymentDeadline = (expiryDate?: string | null): dayjs.Dayjs | null => {
  const expiry = expiryDate ? dayjs(expiryDate) : null
  return expiry?.isValid() ? expiry.subtract(PAYMENT_EXPIRY_BUFFER_SECONDS, "second") : null
}
